import { useMemo } from 'react';
import { isGrandPrixEvent } from '@features/chessrussian/customizations/utils/event-filters';
import { useInfiniteClubEventsQuery } from '@features/club/api/hooks';
import { TournamentShortDto } from '@features/landing/grandprix/typings';

function getTimeToEventMs(evt: TournamentShortDto) {
  return evt.startTimestampMs - Date.now();
}

export function useUpcomingEvents() {
  const { data, isLoading } = useInfiniteClubEventsQuery({
    clubId: '777',
    type: 'upcoming',
  });

  return useMemo(() => {
    let blitz: TournamentShortDto | undefined;
    let rapid: TournamentShortDto | undefined;

    data.forEach((evt) => {
      if (!isGrandPrixEvent(evt)) return;

      const timeToEvent = getTimeToEventMs(evt);

      if (evt.clockControl === 'Blitz') {
        blitz = !blitz || timeToEvent < getTimeToEventMs(blitz) ? evt : blitz;
      }
      if (evt.clockControl === 'Rapid') {
        rapid = !rapid || timeToEvent < getTimeToEventMs(rapid) ? evt : rapid;
      }
    });

    return {
      blitz,
      rapid,
      isLoading,
    };
  }, [data, isLoading]);
}
